import { useEffect } from "react";
import { Box } from "@mui/material";
import { useSearchParams } from "react-router-dom";

import Banner from "../../atoms/Banner/Banner";
import Footer from "../../molecules/Footer/Footer";
import MainContent from "../../templates/MainContent/MainContent";
import { useAppDispatch } from "../../../rtk/_config/hooks";
import { setUser } from "../../../rtk/user/user";
import { setRates, useGetRatesQuery } from "../../../rtk/rates/rates";

const Insurance = () => {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const auth = searchParams.get("auth");
  const price = searchParams.get("price");
  const { data } = useGetRatesQuery();

  useEffect(() => {
    if (auth) {
      dispatch(setUser({ auth }));
    }
  }, [auth, dispatch]);

  useEffect(() => {
    if (data && data?.rates[0].id) {
      dispatch(
        setRates({
          chosen_rate: data?.rates[0].id,
        })
      );
    }
  }, [data, dispatch]);

  return (
    <Box className="Insurance">
      <Banner />
      <Box className="container">
        <MainContent rates={data} price={price} />
      </Box>
      <Footer />
    </Box>
  );
};

export default Insurance;
